
import styles from './Icon.module.scss'

export default (
  {
    src
  }: {
    src: string;
  }
) => {
  return <img className={styles.icon} src={src} alt={''}/>
}